<template>
<div class="chapter">
<div class="inner_page">
<div class="plm_hd">CONTENTS</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Mark_gen_pref">General preface</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Mark_auth_pref">Author’s preface</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Mark_abbreviations">Abbreviations</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Mark_bibliog">Select bibliography</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Mark_intro"><span class="bold">Introduction</span></a>
<div class="sgc-toc-level-2">
<a href="#/Text/Mark_intro#sigil_toc_id_1">1. Mark among the Gospels</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/Mark_intro#sigil_toc_id_2">2. Characteristics of Mark’s Gospel</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/Mark_intro#sigil_toc_id_3">3. The origin of Mark’s Gospel</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/Mark_intro#sigil_toc_id_4">4. Theological emphases</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/Mark_intro#sigil_toc_id_5">5. The structure of Mark’s Gospel</a>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Mark_analysis" title="Link target outside of Sample"><span class="bold">Analysis</span></span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Mark_comment1" title="Link target outside of Sample"><span class="bold">Commentary</span></span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Mark_notes" title="Link target outside of Sample"><span class="bold">Notes</span></span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/author" title="Link target outside of Sample"><span class="bold">About the Author</span></span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/moreIVP" title="Link target outside of Sample"><span class="bold">More Titles from InterVarsity Press</span></span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/copyright" title="Link target outside of Sample"><span class="bold">Copyright</span></span>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Mark_contents.vue?a2e601a0